"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Shortcuts_1 = require("./Shortcuts");
var useShortcut = function (name, listener, enabled) {
    if (enabled === void 0) { enabled = true; }
    var _a = (0, Shortcuts_1.useShortcuts)(), on = _a.on, off = _a.off;
    (0, react_1.useEffect)(function () {
        if (!enabled)
            return;
        on(name, listener);
        return function () { return off(name, listener); };
    }, [name, listener, enabled, on, off]);
};
exports.default = useShortcut;
